module.exports = __webpack_public_path__ + "img/softgrove-9.8a65a3c3.jpeg";